export * from './TotalProfitContent'
export { default } from './TotalProfitContent'
